<template>
  <div class="container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="form.companyId"
            style="margin-right: 10px"
            placeholder="请选择"
            @change="GetSelect"
            clearable
          >
            <el-option
              v-for="item in companyList"
              :key="item.company_id"
              :label="item.company_name"
              :value="item.company_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 160px; display: inline-block"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
          <!-- <el-input v-model="form.type" placeholder="请选择车型" style="width: 210px; display: inline-block; margin-left: 10px;"></el-input> -->
          <el-button type="primary" style="margin-left: 16px" @click="getData"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="addModel"
            v-hasPermi="['系统信息维护-车辆车型维护', '新增']"
            >新增车辆车型</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        height="calc(100% - 110px)"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="车型" align="center">
        </el-table-column>
        <el-table-column prop="number" label="拥有车辆" align="center">
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                @click="readClick(scope.row)"
                v-hasPermi="['系统信息维护-车辆车型维护', '详情']"
                >查看</span
              >
              <span
                class="btn red"
                @click="delClick(scope.row.id)"
                v-hasPermi="['系统信息维护-车辆车型维护', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <edit v-if="dialogVisible" @refresh="getData" />
  </div>
</template>
<script>
import { GetDataModel, GetdataSelectCar, deleteCarModel } from '@/api/system'
import edit from './edit'
import { MessageBox } from 'element-ui'
import { getCompanyList } from '@/api/home'
export default {
  components: { edit },
  data () {
    return {
      dialogVisible: false,
      dialogName: '',
      childform: {
        id: '',
        name: '',
      },
      form: {
        value: '',
        type: '',
        companyId: ''
      },
      options: [
      ],
      table: {
        data: [
        ],
        height: 10,
        currentPage: 1,
        size: 50,
        total: 0
      },
      companyList: [],
    }
  },
  mounted () {
    // this.GetSelect()
    this.getData()
    getCompanyList().then(da => {
      this.companyList = da.data
    })
  },
  methods: {
    refresh () {
      // this.GetSelect()
      this.getData()
    },
    addModel () {
      this.dialogVisible = true
      this.dialogName = '新增'
      this.childform.id = ''
    },
    GetSelect () {
      this.form.type = ''
      if (this.form.companyId) {
        GetdataSelectCar({ companyId: this.form.companyId }).then(res => {
          this.options = res.data.content
        })
      } else {
        this.options = []
      }
    },
    getData () {
      const params = {
        start: this.table.currentPage,
        size: this.table.size,
        name: this.form.value,
        model: this.form.type,
        companyId: this.form.companyId
      }
      GetDataModel(params).then(res => {
        this.table.data = res.data.content
        this.table.total = res.data.total
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      })
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.getData()
    },
    readClick (row) {
      this.dialogVisible = true
      this.dialogName = '编辑'
      this.childform.id = row.id
      this.childform.name = row.name
    },
    delClick (id) {
      MessageBox.confirm('此操作将删除该车型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delModel(id)
      }).catch(() => {
        this.$message('已取消删除')
      });
    },
    delModel (id) {
      deleteCarModel({ id }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功!')
          this.getData()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },

}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
      .red {
        color: #f00;
      }
    }
    .type {
      .iconfont {
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #f00;
      }
    }
    .status {
      &.red {
        color: #f00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.alarm-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>


